/** Status label and colour mappings for governance/entitlement group rows. */

/** Maps raw API status values to user-friendly labels. */
export const STATUS_LABELS: Record<string, string> = {
    "initiated": "Initiated",
    "gov_group_initiated": "Governance Group Initiated",
    "entitlement_initiated": "Entitlement Initiated",
    "completed": "Completed",
    "failed": "Failed",
    "not-initiated": "Not Initiated",
};

/** Maps raw API status values to Ant Design Tag colours. */
export const STATUS_COLORS: Record<string, string> = {
    "initiated": "blue",
    "gov_group_initiated": "gold",
    "entitlement_initiated": "cyan",
    "completed": "green",
    "failed": "red",
    "not-initiated": "default",
};

/** Returns a readable label for a status, falling back to a prettified value. */
export const statusLabel = (status: string): string =>
    STATUS_LABELS[status.toLowerCase()] ??
    status.replace(/[_-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

/** Returns the Tag colour for a status, defaulting to grey for unknown values. */
export const statusColor = (status: string): string =>
    STATUS_COLORS[status.toLowerCase()] ?? "default";
